import { Pipe, PipeTransform } from '@angular/core';


export class SpaceNamePipe implements PipeTransform {
  transform(name: string): any {
    return name ? name.replace(/_/g, ' ') : name;
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{ name: 'spaceName', pure: true }, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
